import { useForm } from 'react-hook-form'
import { TestFormType } from './types'
import { compressImage } from '@src/utils/image'

const useTest = () => {
	const methods = useForm<TestFormType>({
		defaultValues: {
			file: null,
			name: '',
		},
		mode: 'onTouched',
	})
	const compressedFileWatch = methods.watch('compressedFile')

	const handleCompressImage = async (
		e: React.ChangeEvent<HTMLInputElement>,
		destField: keyof TestFormType,
	) => {
		const { files } = e.target
		if (files?.[0]) {
			const compressedImg = await compressImage(files[0])

			methods.setValue(destField, compressedImg)
		}
	}

	return { methods, handleCompressImage, compressedFileWatch }
}

export default useTest
